import script from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"

import "./LayoutView.vue?vue&type=style&index=0&id=ce9f51a0&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9f51a0"]])

export default __exports__